import { useOutletContext } from 'react-router-dom';
import { DocumentList } from '@/pages/Documents';
import type { ProjectContext } from './ProjectShell';

export function ProjectFiles() {
  const { project } = useOutletContext<ProjectContext>();
  return <DocumentList projectId={project.id} />;
}
